export default "<app-users [forCompany]=\"true\"></app-users>\n";